import { render, staticRenderFns } from "./SelectAufnDialog.vue?vue&type=template&id=0df610ba&scoped=true"
import script from "./SelectAufnDialog.vue?vue&type=script&lang=js"
export * from "./SelectAufnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df610ba",
  null
  
)

export default component.exports